import * as React from 'react';

function TriangleDownFilled(props) {
  return (
    <svg
      width="7"
      height="5"
      viewBox="0 0 7 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M3.47057 4.63138L6.67057 0.866672H0.270569L3.47057 4.63138Z" fill="black" />
    </svg>

  );
}

export default TriangleDownFilled;
